import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {TransactionWrapper} from '../../../../model/transactionWrapper';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../shared/error-page/service/error-service';
import {Constants} from '../../../../constants/ebtq-constants';
import {EBTransactionAbstract} from '../../../../model/eBTransactionAbstract';
import {UserDetailsModel} from '../../../../constants/userModel';
import {UtilityService} from '../../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-calculate-loan-pay-off',
  templateUrl: './calculate-loan-pay-off.component.html',
  styleUrls: ['./calculate-loan-pay-off.component.scss']
})
export class CalculateLoanPayOffComponent implements OnInit {

  successMess: boolean;
  loanNumber: string;
  effDate: string;
  successEffDate: string;
  successLoanNumber: string;
  containsError = false;
  errorMsg: string;
  payoffAmount: string;
  showErrorDiv = false;
  errHeading: string;
  errorMessage: string[] = [];
  userDetails: UserDetailsModel;
  utilService: UtilityService;
  currentProcessingDate: string;
  lastDayMonth:any;
  title = 'Calculate Loan Payoff';
  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.utilService = new UtilityService();
    this.successMess = false;
    this.errHeading = Constants.ERROR_HEADER;
    this.errorMessage = [];
    this.userDetails = Constants.USER_DETAILS;

    this.apiService.getCurrentProcessingDate().subscribe(
      (data: any) => {
        this.currentProcessingDate = this.utilService.convertMillisecToDate(data.date);
        this.lastDayMonth = this.utilService.getLastDayOfMonth(this.currentProcessingDate);
        console.log(`lastDayMonth`, this.lastDayMonth);
        this.cdr.detectChanges();
      },
      error => {

      }
    );
  }

  clearBtn() {
    this.successMess = false;
    this.effDate = '';
    this.loanNumber = '';
  }

  CalculateloanPayOff() {
    this.errorMessage = [];
    if (this.validate()) {
      const ebTransactionAbstract = new EBTransactionAbstract();
      ebTransactionAbstract.effectiveDate = this.effDate;
      ebTransactionAbstract.lastUpdatedUserId = sessionStorage.getItem('userID');
      ebTransactionAbstract.fannieMaeLoanNumber = this.loanNumber;

      this.getServiceNumber(ebTransactionAbstract);
    }
  }


  dateToStringConversion()
  {
    const date = this.utilService.convertDateToMillisec(this.effDate);
    return this.utilService.convertMillisecToDate(date);

  }


  validate() {
    this.errorMessage = [];
    this.successMess = false;
    let valid = true;
    if (this.effDate != null && this.effDate !== undefined) {
      const dateString = this.dateToStringConversion();
      this.effDate = dateString;
      console.log('date string', dateString);
    }
    if (this.loanNumber === undefined || !this.loanNumber.startsWith('6') || this.loanNumber === '' || this.loanNumber.length !== 10 || !/^[0-9]+$/.test(this.loanNumber)) {
      valid = false;
      this.errorMessage.push(Constants.LOAN_NUM_ERR_COUNT);
    }
    if (this.effDate === undefined || this.effDate === '' || this.effDate == null) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_EMPTY);
    } else if (!this.validateDateFormat(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDate(this.effDate)) {
      valid = false;
      this.errorMessage.push(Constants.EFF_DATE_ERR_FORMAT);
    } else if (!this.isValidDateYear(this.effDate)) {
      valid = false;
    }
    return valid;
  }

  validateDateFormat(dateStr: string) {
    if (dateStr === undefined || dateStr.trim() === '' || dateStr.length !== 10) {
      return false;
    }
    return true;
  }

  isValidDate(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
    {return false;}

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }


  isValidDateYear(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
    {return false;}

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const year = parseInt(parts[2], 10);
    const month = parseInt(parts[0], 10);
    const date = parseInt(parts[1], 10);
    console.log(`parts, year, month, date`, parts, year, month, date);

    const lparts = this.lastDayMonth.split('/');
    const lyear = parseInt(lparts[2], 10);
    const lmonth = parseInt(lparts[0], 10);
    const ldate = parseInt(lparts[1], 10);
    console.log(`lparts, lyear, lmonth, ldate`, lparts, lyear, lmonth, ldate);

    // Check the ranges of month and year
    if (year > lyear) {
      this.errorMessage.push(Constants.EFF_DATE_YR_ERR_FORMAT);
      return false;
    } else if (year === lyear
      && (month > lmonth || (month === lmonth && date > ldate)) ) {
      this.errorMessage.push(Constants.EFF_DATE_YR_ERR_FORMAT);
      return false;
    } else if (year < 1600) {
      this.errorMessage.push(Constants.PLS_RE_SUBMIT);
      return false;
    }
    return true;
  }

  getQueryPayOff(ebTransactionAbstract: EBTransactionAbstract) {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.parameters[0] = ebTransactionAbstract;
    this.apiService.getQueryPayoff(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.payoffAmount === null || data.payoffAmount.value === null || data.payoffAmount.value === undefined) {
            this.successMess = false;
            this.errorMessage.push(Constants.LOAN_NOT_AVAIL);
          } else {
            this.successMess = true;
            this.payoffAmount = data.payoffAmount.value;
            this.successEffDate = this.effDate;
            this.successLoanNumber = this.loanNumber;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  getServiceNumber(ebTransactionAbstract: EBTransactionAbstract) {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters[0] = this.loanNumber;
    // this.apiService.getServiceNumber(transactionWrapper)
    this.apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
            this.errorMessage.push(Constants.LOAN_NOT_ACTIV);
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
              this.errorMessage.push(Constants.USR_NOT_AUTH + srvrNo);
            } else {
              ebTransactionAbstract.servicerNumber = '' + data.object[0].SRVR_NO;
              this.getQueryPayOff(ebTransactionAbstract);
            }
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.CalculateloanPayOff();}
  }

}
